import { render, staticRenderFns } from "./cloud-platform.vue?vue&type=template&id=268bfa28&scoped=true&"
import script from "./cloud-platform.vue?vue&type=script&lang=js&"
export * from "./cloud-platform.vue?vue&type=script&lang=js&"
import style0 from "./cloud-platform.vue?vue&type=style&index=0&id=268bfa28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268bfa28",
  null
  
)

export default component.exports